// extracted by mini-css-extract-plugin
export default {"cellWrapper":"src-views-homepage-components-StorySnapsInfiniteLoader-StorySnapsInfiniteLoader__cellWrapper--hT_pp"};